import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { useFormikContext } from "formik";
import AddIcon from "@material-ui/icons/AddCircle";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

import { CaseDataResponse } from "../../../types/CaseTypes";
import { useCaseViewStyle } from "../../../components/CaseView/useCaseViewStyle";
import { tokens } from "../../../theme/tokens";
import TaskDialog from "./TaskDialog";
import { useState } from "react";
import { StartIconButton } from "../../shared/helpers/GlobalStylesv5";

function TasksSection() {
  const classes = useCaseViewStyle();
  const { values, setFieldValue } = useFormikContext<CaseDataResponse>();
  const [tasksDialogOpen, setTasksDialogOpen] = useState<boolean>(false);

  const tasks = values.case_detail.case_details.tasks || [];

  const toggleTaskStatus = (index: number) => {
    const currentStatus = tasks[index].status;
    setFieldValue(
      `case_detail.case_details.tasks[${index}].status`,
      !currentStatus,
      false,
    );
  };

  if (tasks.length === 0 && !tasksDialogOpen) {
    return (
      <div className={classes.rightContainer}>
        <div className={classes.rightInformationDiv}>
          <div className={classes.cardHead}>
            <span className={classes.cardHeadIcon}>
              <ChecklistOutlinedIcon />
            </span>
            <h5 className={classes.tabHeading}>Tasks</h5>
          </div>
          <div
            className={classes.cardBodyPad}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <StartIconButton
              onClick={() => setTasksDialogOpen(true)}
              icon={<AddIcon />}
            >
              Add new task
            </StartIconButton>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={classes.rightContainer}>
        <div className={classes.rightInformationDiv}>
          <div className={classes.cardHead}>
            <span className={classes.cardHeadIcon}>
              <ChecklistOutlinedIcon />
            </span>
            <h5 className={classes.tabHeading}>Tasks</h5>
            <OpenInFullIcon
              onClick={() => setTasksDialogOpen(true)}
              style={{
                marginLeft: "auto",
                cursor: "pointer",
                fontSize: "1.125rem",
                color: tokens.color.text.secondary,
              }}
            />
          </div>
          <div className={classes.cardBodyPad}>
            {tasks.map((task, index) => (
              <ListItem
                key={index}
                disableGutters
                divider
                style={{ padding: "0px" }}
              >
                <ListItemIcon>
                  {task.status ? (
                    <CheckCircleOutlineIcon
                      className={classes.taskIcon}
                      onClick={() => toggleTaskStatus(index)}
                    />
                  ) : (
                    <RadioButtonUncheckedIcon
                      className={classes.taskIcon}
                      onClick={() => toggleTaskStatus(index)}
                    />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={task.title}
                  className={classes.taskListText}
                  onClick={() => setTasksDialogOpen(true)}
                  style={{
                    color: tokens.color.brand.primaryAction,
                    cursor: "pointer",
                  }}
                />
              </ListItem>
            ))}
          </div>
        </div>
      </div>

      <TaskDialog
        open={tasksDialogOpen}
        onClose={() => setTasksDialogOpen(false)}
      />
    </>
  );
}

export default TasksSection;
